import { Component } from '@angular/core';
import { AutoMlService } from 'src/app/core/service/auto-ml.service';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';

@Component({
  selector: 'app-flow-bottom-area',
  templateUrl: './flow-bottom-area.component.html',
  styleUrls: ['./flow-bottom-area.component.scss']
})
export class FlowBottomAreaComponent {
  selectedTab: string = 'tab1';
  tableKeys:any[]=[

      "activity",
      "started",
      "completed",
      "status",
      "tool",
      "details"

  ];
  page=1;
  selectedPage=5;
  testData:any[] = [
    {
      activity:'Validation',
      started:'8:09:30',
      completed:'8:10:22',
      status:'Success',
      tool:'Sample dataset',
      details:'All Pipeline components ready.',
    },
    {
      activity:'Validation',
      started:'8:09:30',
      completed:'8:10:22',
      status:'Success',
      tool:'Sample dataset',
      details:'All Pipeline components ready.',
    },
    {
      activity:'Validation',
      started:'8:09:30',
      completed:'8:10:22',
      status:'Error',
      tool:'Sample dataset',
      details:'Invalid input.',
    },
    {
      activity:'Validation',
      started:'8:09:30',
      completed:'8:10:22',
      status:'Error',
      tool:'Sample dataset',
      details:'Invalid input.',
    },
    {
      activity:'Validation',
      started:'8:09:30',
      completed:'8:10:22',
      status:'Error',
      tool:'Sample dataset',
      details:'Invalid input.',
    },
    
  ];

  pageArr=[
    5,10,25
  ];
  selectTab(tabName: string): void {
    this.selectedTab = tabName;
  }
  constructor(
    public _fb:FlowBuilderService,
    public autoMlService:AutoMlService
  ){}



  incriement(){

  }
  decriement(){

  }

}
